// removed by extract-text-webpack-plugin
module.exports = {"root":"FilterPlain__root__3paTI","filterLabel":"FilterPlain__filterLabel__viHMh","filterLabelSelected":"FilterPlain__filterLabelSelected__1MXGK","labelButton":"FilterPlain__labelButton__ZCL3u","clearButton":"FilterPlain__clearButton__3kMWg","plain":"FilterPlain__plain__81q_k","isOpen":"FilterPlain__isOpen__3LDda"};


//////////////////
// WEBPACK FOOTER
// ./src/components/FilterPlain/FilterPlain.css
// module id = 1815
// module chunks = 0